import React from "react";
import SubPageLayout from "../components/SubPageLayout";
import { NAAVI_GALLERY } from "../data/site";

export default function Gallery() {
  return (
    <SubPageLayout
      eyebrow="Gallery"
      title={<>Tiny milestones, <span className="italic font-normal">giant smiles</span>.</>}
      subtitle="Glimpses of an ordinary day at our extraordinary little world."
      accent="turquoise"
      decor="circle"
    >
      <section className="py-16 md:py-24 bg-[#FDFDF9]">
        <div className="max-w-7xl mx-auto px-5 md:px-8">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3" data-testid="gallery-grid">
            {NAAVI_GALLERY.concat(NAAVI_GALLERY).map((url, i) => (
              <div
                key={i}
                className={`overflow-hidden rounded-3xl ${
                  i % 5 === 0 ? "row-span-2 aspect-square" : "aspect-square"
                }`}
              >
                <img decoding="async"
                  src={url}
                  alt={`Moment ${i + 1}`}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </section>
    </SubPageLayout>
  );
}
